import { useMemo } from 'react';
import { useWidgetPortalContainer } from './embeddableWidgetPortalContext';

type EmbeddablePickerPortalSlotProps = {
  popper?: { container: () => HTMLElement };
  dialog?: { container: () => HTMLElement };
};

/**
 * Slot props for MUI X date pickers to portal into the widget container.
 */
export function useEmbeddablePickerPortalSlotProps(): EmbeddablePickerPortalSlotProps {
  const container = useWidgetPortalContainer();

  return useMemo(() => {
    if (!container) {
      return {};
    }

    const getContainer = (): HTMLElement => container;

    return {
      popper: { container: getContainer },
      dialog: { container: getContainer },
    };
  }, [container]);
}
